<template>
  <div class="row">
    <div class="col-sm-8">
      <div class="panel panel-default">
        <div class="panel-body">
          <form method="POST" :action="url" v-if="!done">
            <loader-box v-if="loading"/>
            <input type="hidden" name="_token" id="_token" v-model="promo._token">
            <input type="hidden" name="test" id="test" v-model="promo.test">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="from" class="control-label">Date début</label>
                  <input type="hidden" name="from" id="from" v-model="promo.from" data-min-date="" data-max-date="today"
                         class="form-control datetime-picker">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="to" class="control-label">Date fin</label>
                  <input type="hidden" name="to" id="to" v-model="promo.to" data-min-date="" data-max-date="today"
                         class="form-control datetime-picker">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="travel_count" class="control-label">Nombre de voyages</label>
                  <input type="text" name="travel_count" id="travel_count" class="form-control"
                         v-model="promo.travel_count">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="value" class="control-label">Valeur code promo (%)</label>
                  <input type="number" name="value" id="value" class="form-control" v-model="promo.value"/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="expire_at" class="control-label">Date d'expiration</label>
                  <input type="hidden" name="expire_at" id="expire_at" class="form-control datetime-picker"
                         v-model="promo.expire_at"/>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="message" class="control-label">Message</label>
              <textarea style="min-height: 300px" name="message" id="message" class="form-control" v-model="promo.message"></textarea>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <button @click.prevent="submitGenerate(true)" class="app-button-inverted btn-block"
                        style="margin-top: 0px;">
                  Estimation
                </button>
              </div>
              <div class="col-sm-6">
                <button type="submit" @click.prevent="submitGenerate(false)" class="btn btn-block btn-primary">Générer <i class="fa fa-gift"></i></button>
              </div>
            </div>
          </form>
          <a href="#" v-else @click.prevent="reload()">Générer d'autres codes promos</a>
        </div>
      </div>

      <div class="panel panel-default" v-if="!done">
        <div class="panel-heading">{{ message }}</div>
        <ul class="list-group">
          <li v-for="user in users" class="list-group-item">
            <strong>{{ user.full_name }}</strong>: {{ user.booking_count }} réservation(s) dont {{ user.paid_booking_count }} payée(s)
          </li>
        </ul>
      </div>
    </div>

    <div class="col-sm-4" v-if="!done">
      <div class="list-group">
        <a v-for="key in Object.keys(variables)" href="#" class="list-group-item" @click.prevent="addVariable(key)">
          <h4 class="list-group-item-heading">{{ key }}</h4>
          <p class="list-group-item-text">{{ variables[key] }}</p>
        </a>
      </div>
      <div class="panel panel-default">
        <div class="panel panel-default" v-if="smsRender">
          <div class="panel-body" v-html="smsRender"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import appAxios from '../app-axios'
  import LoaderBox from './Loader/LoaderBox'
  import {handleErrors, resetErrors} from '../form'
  import AppApiResponse from "../AppApiResponse";

  export default {
    components: {LoaderBox},
    props: {
      url: {type: String},
      csrfToken: {type: String},
      variablesJson: {type: String},
      dummyUserJson: {type: String}
    },
    data () {
      return {
        done: false,
        message: '',
        loading: false,
        users: [],
        promo: {
          message: ':greetings :full_name,:space ...',
          test: false,
          from: '',//new Date(Date.now() - 1000 * 60 * 24 * 7), // one week ago
          to: '',//new Date(),
          value: '',
          expire_at: ''//new Date(Date.now() + 1000 * 60 * 24 * 365)
        }
      }
    },
    computed: {
      smsRender () {
        let message = this.promo.message
        Object.keys(this.variables).forEach(key => {
          message = message.split(key).join(this.dummyUser[key])
        })
        return message
      },
      variables () {
        return JSON.parse(this.variablesJson)
      },
      dummyUser () {
        return JSON.parse(this.dummyUserJson)
      },
    },
    methods: {
      reload () {
        window.location.reload()
      },
      addVariable (key) {
        this.promo.message += ' ' + key + ' '
      },
      submitGenerate (isTest) {
        this.users = []
        this.message = ''
        resetErrors(Object.keys(this.promo), {
          classList: ['has-error']
        })
        this.promo.test = isTest
        this.loading = true
        appAxios.post(this.url, this.promo)
          .then(apiResponse => {
            this.message = apiResponse.getMessage()
            this.users = apiResponse.getData()
            if (!isTest) {
              this.done = true
            }
          })
          .catch(apiResponse => {
            console.error(apiResponse)
            if (apiResponse instanceof AppApiResponse) {
              this.message = apiResponse.getMessage()
              handleErrors(apiResponse.getData(), Object.keys(this.promo), {
                errorClass: 'has-error',
                feedbackClass: 'help-block'
              })
            }
          })
          .then(_ => this.loading = false)
      },
    },
    mounted () {
      this.promo._token = this.csrfToken
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/component/PromoGenerate.vue